import React from "react";
import { TOUR_DATA_BAR } from "constants/ui-constants";
import Masterbar from "./Masterbar";

export default () => <Masterbar {...TOUR_DATA_BAR} />;
